<!-- TEMPLATE -->
<template>
  <div :class='contactDetailsClass'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-remove-restore
          v-if="canRemoveContact()"
          slot="title-items"
          :is-removed="isDeleted"
          text-remove="Verwijderen" :remove-icon="trashIcon" @remove="deleteContact"
          text-restore="Herstellen" :restore-icon="lockOpenIcon" @restore="restoreContact"
      />
      <dean-section-title-item
          v-if="canSaveCustomerContact()"
          :icon='saveIcon'
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="processContact"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-form-row id="givenName" v-model="contactData.personalName.givenName"
                       label="Voornaam"
                       :required-field="true"
                       :disabled='!canSaveCustomerContact()'
                       :warning="$v.data.personalName.givenName.$error"></dean-form-row>
        <dean-form-row id="surnamePrefix" v-model="contactData.personalName.surnamePrefix"
                       label="Tussenvoegsels"
                       :disabled='!canSaveCustomerContact()'></dean-form-row>
        <dean-form-row id="surname" v-model="contactData.personalName.surname" label="Achternaam"
                       :required-field="true"
                       :disabled='!canSaveCustomerContact()'
                       :warning="$v.data.personalName.surname.$error"
                       @focus="$v.data.personalName.surname.$touch()"></dean-form-row>
        <dean-form-row id="jobTitle" v-model="contactData.personalName.jobTitle"
                       :disabled='!canSaveCustomerContact()'
                       label="Functietitel"></dean-form-row>
        <dean-form-row id="phoneNumber" v-model="contactData.phoneNumber" label="Telefoonnummer"
                       :disabled='!canSaveCustomerContact()'></dean-form-row>
        <dean-form-row id="emailAddress" v-model="contactData.emailAddress" label="E-mailadres"
                       :required-field="true"
                       :disabled='!canSaveCustomerContact()'
                       :warning="$v.data.emailAddress.$error"
                       @focus="$v.data.emailAddress.$touch()"></dean-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification, validationMessage} from '@/mixins/validations';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';

  import {
    deanAlertDialog,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    saveIcon,
    lockOpenIcon,
    trashIcon,
    warningIcon,
    invoicesIcon,
    offersIcon,
    summeryIcon,
    usersIcon,
    businessIcon,
    ordersIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import DeanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {mixins} from 'vue-class-component';

  @Component({
    components: {
      deanSectionTitleRemoveRestore,
      DeanMultiSelectFormRow,
      DeanInputSwitchFormRow,
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuCustomerMixin) {
    public saveIcon: object = saveIcon;
    public lockOpenIcon: object = lockOpenIcon;
    public trashIcon: object = trashIcon;
    public showSomething: boolean = false;
    public timeout?: number;
    public data: {
      id: any,
      organizationId: any,
      personalName: {
        givenName: any,
        surnamePrefix: any,
        surname: any,
        jobTitle: any,
      },
      emailAddress: any,
      phoneNumber: any,
    } = {
      id: null,
      organizationId: null,
      personalName: {
        givenName: null,
        surnamePrefix: null,
        surname: null,
        jobTitle: null,
      },
      emailAddress: null,
      phoneNumber: null,
    };
    public isDeleted: boolean = false;

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          personalName: {
            givenName: {required},
            surname: {required},
          },
          emailAddress: {required, email},
        },
      };
    }

    get contactDetailsClass() {
      let value = 'partner-add';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get contactData(): {
      id: any,
      organizationId: any,
      personalName: {
        givenName: any,
        surnamePrefix: any,
        surname: any,
        jobTitle: any,
      },
      phoneNumber: any,
      emailAddress: any,
    } {
      return this.data;
    }

    get headerTitle(): string {
      return (this.$route.params.contactId !== undefined) ? 'Contact wijzigen' : 'Contact toevoegen';
    }

    public contactDetails(): void {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/customer.contact.info', {
        contactId: this.$route.params.contactId,
      }).then((response) => {

          this.isDeleted = Boolean(response.data.deleted);

          this.data = {...this.data, ...response.data};
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => this.$store.dispatch('setLoadOverlay', false));
    }

    public created() {
      if (this.$route.params.contactId) {
        this.contactDetails();
      }
      this.buildSideMenuCustomer(this.$route.params.pid);
    }

    public deleteContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.contactId,
        context: 'customers',
        contextId: this.$route.params.pid,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
      });
    }

    public restoreContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.contactId,
        context: 'customers',
        contextId: this.$route.params.pid,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
        state: 'restoring',
      });
    }

    public processContact() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        this.data.id = this.$route.params.contactId ?? null,
        this.data.organizationId = this.$route.params.pid,

        axios
          .post('/-/trade/api/customer.contact.save', this.contactData).then(
          (response) => {
            this.data = {...this.data, ...response.data};

            this.$toast({
              icon: saveIcon,
              text: 'Contact opgeslagen',
              theme: 'success',
            });

          },
          (error) => {
            if (error.response.data.errors) {
              let errorText = 'Fout';

              switch (error.response.data.errors[0].code) {
                case 'ERR_EMAIL_NOT_AVAILABLE':
                  errorText = 'E-mailadres is niet beschikbaar.';
                  break;
              }

              this.$toast(validationMessage(errorText));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => this.$store.dispatch('setLoadOverlay', false));
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public canSaveCustomerContact(): boolean {
      if (this.isDeleted) {
        return false;
      }

      if (
          this.contactData?.id
          && this.$store.getters.getUser.privileges.includes('update-customer-contact')
      ) {
        return true;
      }

      if (
          this.contactData?.id === null
          && this.$store.getters.getUser.privileges.includes('create-customer-contact')
      ) {
        return true;
      }

      return false;
    }

    public canRemoveContact(): boolean {
      if (
          this.$route.name === 'customer.contact.edit'
          && this.$store.getters.getUser.privileges.includes('change-status-customer-contact')
      ) {
        return true;
      }

      return false;
    }

    public mounted() {
      deanDialogBus.$on('contactStatusChange', () => {
        this.contactDetails();
      });
    }

    public destroyed() {
      deanDialogBus.$off('contactStatusChange');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
